export default __webpack_public_path__ + "static/media/tiendas_back.01609df9.jpg";